export default "__VITE_ASSET__BI6lYql2__"